import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as approvalApi from '../../lib/api/approval';
import * as techApi from '../../lib/api/tech';
import * as projectApi from '../../lib/api/project';

import { useDispatch } from 'react-redux';

import DetailTemplate from '../../components/common/template/DetailTemplate';
import { setTechRslt } from '../../modules/techModule/techRslt';
import { setOrder } from '../../modules/projectModule/order';
import ApprovalForm from '../../components/common/approval/ApprovalForm';

const ApprovalFormContainer = ({ docuCd, user, type }) => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [apprDoc, setApprDoc] = useState(null);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      docuYn: 'Y',
      docuTxt: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      docuYn: yup
        .string()
        .required('결재 완료여부는 반드시 선택되어야 합니다.'),
    }),
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);
      onSave(values);
      formik.resetForm();
      setSubmitting(false);
    },
  });

  const reloadData = async () => {
    setLoading(true);

    try {
      const res = await approvalApi.getCurApprovalDetByCd(docuCd);

      if (res.data) {
        if (type === 'tech') {
          const techRslt = await techApi.getRsltInfo(docuCd);
          dispatch(setTechRslt(techRslt.data.info));
        } else if (type === 'order') {
          const prjRes = await projectApi.getOrderInfoAll(docuCd);
          dispatch(setOrder(prjRes.data));
        }
        setApprDoc(res.data.list);
      }
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  };

  const onSave = async (values) => {
    let dataToSubmit = {
      docuCd: docuCd,
      docuUuid: apprDoc.docuUuid,
      docuYn: values.docuYn,
      docuTxt: values.docuTxt,
    };

    try {
      if (type === 'tech') {
        const res = await approvalApi.addTechDoc(dataToSubmit);
        if (res.data) {
          reloadData();
        }
      } else if (type === 'order') {
        const res = await approvalApi.addOrderDoc(dataToSubmit);
        if (res.data) {
          reloadData();
        }
      } else if (type === 'tax') {
        const res = await approvalApi.addTaxDoc(dataToSubmit);
        if (res.data) {
          reloadData();
        }
      }

      navigate(`/approvalmng`); //결재 완료후 리스트 화면으로 이동함.
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  useEffect(() => {
    //async를 사용하는 함수 따로 선언
    const fetchData = async () => {
      setLoading(true);

      try {
        const res = await approvalApi.getCurApprovalDetByCd(docuCd);

        setApprDoc(res.data.list);
      } catch (err) {
        console.log(err);
      }

      setLoading(false);
    };
    fetchData();
  }, [docuCd]);

  if (loading) {
    return <div>로딩중</div>;
  }

  if (loading) {
    return <div>로딩중</div>;
  }

  //아직 값이 없을때
  if (!apprDoc || !user) {
    return null;
  }

  if (apprDoc.docuUsr !== user.usrUuid) {
    //현재 결재자 아님.
    return null;
  }

  //article값이 유효할때
  return (
    <DetailTemplate title="결재확인">
      <ApprovalForm apprDoc={apprDoc} user={user} formik={formik} />
    </DetailTemplate>
  );
};

export default ApprovalFormContainer;
